// extracted by mini-css-extract-plugin
export default {"container":"style_container__MWIUQ","top":"style_top__B-PP5","middle":"style_middle__0Ch7H","bottom":"style_bottom__j0l6C"};